export default __webpack_public_path__ + "static/media/dnv-updapt-2.94306480.jpg";